if (document.querySelector('[data-footer]')) {
  // DOM elements
  var footerElement = document.querySelector('[data-footer]');
  var footerHue = 0;

  // lazy loading for images and lottie animations
  lazyLoadSectionFiles(footerElement, 
    footerElement.querySelectorAll("[data-lazy-loading-image]"), 
    undefined, undefined
  );

  // animate bg gradient
  function animateGradient() {
    // Update hue value
    footerHue = (footerHue + 1) % 360;
    // Apply the linear gradient with the updated hue value
    footerElement.style.backgroundImage = `linear-gradient(to bottom left, #000000 50%, hsla(${footerHue}, 100%, 50%, 0.3) 62%, hsla(${(footerHue + 60) % 360}, 100%, 50%, 0.3) 78%)`;
  }

  var animateFooterBg = null;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        if (animateFooterBg) {
          clearInterval(animateFooterBg);
          animateFooterBg = null;
        }
        return;
      }

      if (animateFooterBg) return;
      animateFooterBg = setInterval(animateGradient, 50);
    });
  }, { threshold: 0 });
  observer.observe(footerElement);

  // dynamic pictures (make fade from one to another picture when clicked on the picture)
  var footerChangingPictureContainerMobile = document.querySelector('[data-footer-changing-picture-mobile]');
  var footerChangingPictureContainerDesktop = document.querySelector('[data-footer-changing-picture-desktop]');
  var footerCurrentIndex = -1;
  var footerChangingPictureInProgress = false;
  var footerChangingPictures = [
    {
      src: 'https://cdn.shopify.com/s/files/1/1715/6045/files/footer-boy-character.webp?v=1689324230',
      alt: 'A boy character',
      style: ''
    },
    {
      src: 'https://cdn.shopify.com/s/files/1/1715/6045/files/footer-cone-character.webp?v=1689324229',
      alt: 'A cone character',
      style: ''
    },
    {
      src: 'https://cdn.shopify.com/s/files/1/1715/6045/files/footer-girl-character.webp?v=1689324229',
      alt: 'A girl character',
      style: ''
    },
    {
      src: 'https://cdn.shopify.com/s/files/1/1715/6045/files/footer-hand-tooth.webp?v=1689324230',
      alt: 'A hand holding a toothbrush',
      style: ''
    },
    {
      src: 'https://cdn.shopify.com/s/files/1/1715/6045/files/footer-map-picture.webp?v=1689787302',
      alt: 'A map of the USA with the happy children\'s faces',
      style: ''
    },
    {
      src: 'https://cdn.shopify.com/s/files/1/1715/6045/files/footer-money-character.webp?v=1689324230',
      alt: 'A money character',
      style: ''
    },
    {
      src: 'https://cdn.shopify.com/s/files/1/1715/6045/files/footer-money-pig-character.webp?v=1689324230',
      alt: 'A pig with money character',
      style: ''
    },
    {
      src: 'https://cdn.shopify.com/s/files/1/1715/6045/files/footer-usa-flag.webp?v=1689324230',
      alt: 'The USA flag',
      style: ''
    },
  ];

  if (window.innerWidth < 768) {
    window.addEventListener('load', () => { changePicture(footerChangingPictureContainerMobile); });
    footerChangingPictureContainerMobile.addEventListener('click', () => {
      changePicture(footerChangingPictureContainerMobile);
    });
  } else {
    window.addEventListener('load', () => { changePicture(footerChangingPictureContainerDesktop); });
    footerChangingPictureContainerDesktop.addEventListener('click', () => {
      changePicture(footerChangingPictureContainerDesktop);
    });
  }

  function changePicture(footerChangingPictureContainer) {
    if (footerChangingPictureInProgress) return;

    const oldImg = footerChangingPictureContainer.querySelector('img');
    footerChangingPictureInProgress = true;

    let nextIndex;
    do {
        nextIndex = getRandomNumber(0, footerChangingPictures.length);
    } while(nextIndex === footerCurrentIndex);
    const randomPicture = footerChangingPictures[nextIndex];
    footerCurrentIndex = nextIndex;
    const newImg = document.createElement('img');
    newImg.src = randomPicture.src;
    newImg.alt = randomPicture.alt;
    newImg.style = randomPicture.style;
    newImg.classList.add("footer__dynamic-img");
    footerChangingPictureContainer.appendChild(newImg);

    oldImg?.classList.remove('fade-in');
    setTimeout(() => { newImg.classList.add('fade-in'); }, 0);
    setTimeout(() => { oldImg?.remove(); footerChangingPictureInProgress = false; }, 500);
  }

  function getRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }
}